import { atom } from 'recoil';

const openDrawerState = atom({
	key: 'openDrawer',
	default: true,
});

export default openDrawerState;
